<template>
  <modal>
    <template slot="modal-header">
      <h2 class="mt-3">Select {{scope === 'agency' ? 'Offices' : 'Agents'}}</h2>
    </template>
    <template slot="modal-body">
      <div class="px-3">
        <vue-good-table
          @on-selected-rows-change="handleSelectionChanged"
          :columns="columns"
          :rows="rows"
          :select-options="{enabled: true}"
          max-height="60vh"
          :fixed-header="true"
        ></vue-good-table>
      </div>
      <div class="d-flex align-items-center justify-content-between px-3 pt-5">
        <button class="btn btn-quaternary" @click="handleClose">Cancel</button>
        <button class="btn btn-primary" @click="handleSelect">Select</button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../../../helpers/Modal.vue';
import {VueGoodTable} from 'vue-good-table';

export default {
  props: ['label', 'data', 'onClose', 'scope'],
  data() {
    return {
      selectedItems: [],
    };
  },
  components: {
    Modal,
    VueGoodTable,
  },
  computed: {
    columns() {
      return this.data.getColumns();
    },
    rows() {
      return this.data.getRows();
    },
  },
  methods: {
    handleSelectionChanged(props) {
      this.selectedItems = props.selectedRows;
    },
    handleSelect() {
      this.$emit('items-selected', this.selectedItems);
      this.handleClose();
    },
    handleClose() {
      this.onClose();
    },
  },
};
</script>
